import React from 'react';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';
function LabradorIcon() {
  return <svg viewBox="0 0 64 64" className="w-full h-full" fill="none" data-id="element-142">
      <circle cx="32" cy="32" r="30" fill="#F5E6D3" data-id="element-143" />
      <ellipse cx="18" cy="22" rx="8" ry="12" fill="#D4A574" data-id="element-144" />
      <ellipse cx="46" cy="22" rx="8" ry="12" fill="#D4A574" data-id="element-145" />
      <circle cx="32" cy="34" r="16" fill="#E8C99B" data-id="element-146" />
      <ellipse cx="32" cy="40" rx="8" ry="5" fill="#D4A574" data-id="element-147" />
      <circle cx="32" cy="38" r="3" fill="#4A3728" data-id="element-148" />
      <circle cx="25" cy="30" r="2.5" fill="#4A3728" data-id="element-149" />
      <circle cx="39" cy="30" r="2.5" fill="#4A3728" data-id="element-150" />
      <circle cx="26" cy="29" r="1" fill="white" data-id="element-151" />
      <circle cx="40" cy="29" r="1" fill="white" data-id="element-152" />
      <path d="M28 44 Q32 48 36 44" stroke="#4A3728" strokeWidth="1.5" fill="none" strokeLinecap="round" data-id="element-153" />
    </svg>;
}
function MischlingIcon() {
  return <svg viewBox="0 0 64 64" className="w-full h-full" fill="none" data-id="element-154">
      <circle cx="32" cy="32" r="30" fill="#F0E4D8" data-id="element-155" />
      <ellipse cx="16" cy="20" rx="7" ry="13" fill="#8B6F47" transform="rotate(-10 16 20)" data-id="element-156" />
      <ellipse cx="48" cy="20" rx="7" ry="13" fill="#C4A882" transform="rotate(10 48 20)" data-id="element-157" />
      <circle cx="32" cy="34" r="16" fill="#C4A882" data-id="element-158" />
      <path d="M20 30 Q32 26 44 30" fill="#8B6F47" data-id="element-159" />
      <ellipse cx="32" cy="40" rx="7" ry="4.5" fill="#A08060" data-id="element-160" />
      <circle cx="32" cy="38" r="2.5" fill="#4A3728" data-id="element-161" />
      <circle cx="25" cy="31" r="2.5" fill="#4A3728" data-id="element-162" />
      <circle cx="39" cy="31" r="2.5" fill="#4A3728" data-id="element-163" />
      <circle cx="26" cy="30" r="1" fill="white" data-id="element-164" />
      <circle cx="40" cy="30" r="1" fill="white" data-id="element-165" />
      <path d="M28 44 Q32 47 36 44" stroke="#4A3728" strokeWidth="1.5" fill="none" strokeLinecap="round" data-id="element-166" />
    </svg>;
}
function GoldenRetrieverIcon() {
  return <svg viewBox="0 0 64 64" className="w-full h-full" fill="none" data-id="element-167">
      <circle cx="32" cy="32" r="30" fill="#FFF0DC" data-id="element-168" />
      <ellipse cx="16" cy="24" rx="9" ry="11" fill="#D4A04A" data-id="element-169" />
      <ellipse cx="48" cy="24" rx="9" ry="11" fill="#D4A04A" data-id="element-170" />
      <circle cx="32" cy="34" r="16" fill="#E8BE6A" data-id="element-171" />
      <path d="M16 34 Q14 42 20 44" fill="#D4A04A" data-id="element-172" />
      <path d="M48 34 Q50 42 44 44" fill="#D4A04A" data-id="element-173" />
      <ellipse cx="32" cy="41" rx="8" ry="5" fill="#D4A04A" data-id="element-174" />
      <circle cx="32" cy="39" r="3" fill="#4A3728" data-id="element-175" />
      <circle cx="25" cy="30" r="2.5" fill="#4A3728" data-id="element-176" />
      <circle cx="39" cy="30" r="2.5" fill="#4A3728" data-id="element-177" />
      <circle cx="26" cy="29" r="1" fill="white" data-id="element-178" />
      <circle cx="40" cy="29" r="1" fill="white" data-id="element-179" />
      <path d="M27 45 Q32 49 37 45" stroke="#4A3728" strokeWidth="1.5" fill="none" strokeLinecap="round" data-id="element-180" />
      <path d="M22 26 Q24 24 26 26" stroke="#C49030" strokeWidth="2" fill="none" data-id="element-181" />
      <path d="M38 26 Q40 24 42 26" stroke="#C49030" strokeWidth="2" fill="none" data-id="element-182" />
    </svg>;
}
export function Testimonials() {
  const reviews = [{
    text: 'Ich war skeptisch, aber nach 2 Wochen hatte Balu zum ersten Mal wieder einen ruhigen Magen. Wir sind so erleichtert.',
    author: 'Sandra (Hund: Balu, Labrador, 4 Jahre)',
    icon: <LabradorIcon data-id="element-183" />
  }, {
    text: 'Charlie hatte wochenlang morgendliches Würgen und Grasfressen. Nach dem Topping hat sich das innerhalb von 10 Tagen komplett gelegt.',
    author: 'Thomas (Hund: Charlie, Mischling, 6 Jahre)',
    icon: <MischlingIcon data-id="element-184" />
  }, {
    text: 'Endlich ein Zusatz, der wirklich wirkt. Sonnenblume ist sichtbar fitter, aktiver, wacher – ohne ständige Übelkeit.',
    author: 'Nadja (Hund: Sonnenblume, Golden Retriever, 3 Jahre)',
    icon: <GoldenRetrieverIcon data-id="element-185" />
  }];
  return <section className="py-16 bg-cardBg" data-id="element-186">
      <div className="max-w-5xl mx-auto px-4" data-id="element-187">
        <h2 className="font-handwritten text-4xl text-center text-forestGreen mb-12" data-id="element-188">
          Das sagen andere Hundeeltern
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-189">
          {reviews.map((review, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.2
        }} className="bg-cream p-8 rounded-xl shadow-md border border-warmBrown/10 flex flex-col h-full" data-id="element-190">
              <div className="flex items-center gap-4 mb-4" data-id="element-191">
                <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-warmBrown/20 shrink-0 bg-warmBrown/5" data-id="element-192">
                  {review.icon}
                </div>
                <div data-id="element-193">
                  <div className="flex gap-1 mb-1" data-id="element-194">
                    {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-warmBrown text-warmBrown" data-id="element-195" />)}
                  </div>
                  <p className="font-serif font-bold text-forestGreen text-sm" data-id="element-196">
                    {review.author}
                  </p>
                </div>
              </div>
              <p className="font-serif text-gray-800 italic flex-grow" data-id="element-197">
                "{review.text}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}